import React, { useEffect, useRef } from 'react'
import '../utils/Style/component/ViewQr.scss'
import { resetRequest, setRequestData } from "../features/orderDetailsSlice";
import { useDispatch, useSelector } from 'react-redux';
import useTodoApi from '../api/TodoApi';
import { useReactToPrint } from 'react-to-print';

function ViewQr({ orderID, onClose }) {

    const todoOrderDetails = useSelector((state) => state.todo.todoOrderDetails);
    const ordersTodo = useSelector(state => state.todo.ordersToDo);
    const { GetOrderQr, GetOrder, qrCode } = useTodoApi();
    const printQr = useRef();


    console.log("order", ordersTodo);

    useEffect(() => {
        if (orderID) {
            GetOrderQr(orderID); 
        }
    }, [orderID]);


    console.log(ordersTodo.OrderID);

    const handlePrint = useReactToPrint({
        content: () => printQr.current,
      });

    return (
        <div className='col-12'>
            <div className="secondcnt">
            <div className="close">
                        <button
                        className="close-btn"
                        onClick={onClose}
                        >
                            X
                        </button>
                    </div>
                <div className='viewQr'>
                    <div className='top-icon'>
                        <img src='/Images/NewOrders.svg' alt="" />
                    </div>
                        <div className='qrOrder'>QR For Order</div>
                        <div className='qr-code'>
                        <div className="qrOrderinput" ref={printQr} style={{textAlign: "center"}}>
                            <img 
                            src={qrCode}
                            alt="QR Code" 
                            />
                            <div className="order-numberID" style={{textAlign: "center"}}>
                                OrderID <span className="id-mumber">{orderID}</span>
                            </div>
                            </div>
                            </div>
                            <div className="button-order">
                            <button className="print-btn" onClick={handlePrint}>
                                Print QR
                            </button>
                            </div>
                        </div>
                    </div>
                </div>
    )
}

export default ViewQr;